import {checkNavBtn, getIndexVisibleImage, isFirstImageInGallery, isLastImageInGallery} from '../swipe-handler';
import {SPEED_ANIMATION, SWIPE_DIRECTION_LEFT, SWIPE_DIRECTION_RIGHT} from '../consts';

export const endGalleryBlockSwipe = function (gallery, direction) {
    let indexVisibleImage = getIndexVisibleImage(gallery);
    let left = gallery.width() * (Math.ceil(indexVisibleImage)) * -1;

    if (direction === SWIPE_DIRECTION_RIGHT) {
        left = gallery.width() * (Math.floor(indexVisibleImage)) * -1;

        if (isFirstImageInGallery(gallery))
            left = 0;
    }

    if (direction === SWIPE_DIRECTION_LEFT && isLastImageInGallery(gallery))
        left = gallery.width() * (gallery.find('.material-gallery-images-container__image').length - 1) * -1;

    gallery.find('.material-gallery-images-container').animate({left: left}, SPEED_ANIMATION, function () {
        checkNavBtn(gallery);
    });
};

export const endGallerySwipe = function (gallery, direction) {
    let indexVisibleImage = getIndexVisibleImage(gallery);

    if(Number.isInteger(indexVisibleImage) === false || isFirstImageInGallery(gallery))
        return false;

    let nextImageIndex = (indexVisibleImage + 1);

    if (direction === SWIPE_DIRECTION_RIGHT)
        nextImageIndex = indexVisibleImage - 1;

    let left = gallery.width() * nextImageIndex * -1;

    gallery.attr('animation', true);

    gallery.find('.material-gallery-images-container').animate({left: left}, SPEED_ANIMATION, function () {
        gallery.removeAttr('animation');
        checkNavBtn(gallery);
    });
};
